<template>
    <div>
        <div v-if="!canEdit">
            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.technical_means">
                <h3 slot="header" class="mb-0">{{ $t('logs.technical-means') }}</h3>
                <div class="tinymce" v-html="log.technical_means"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.zones">
                <h3 slot="header" class="mb-0">{{ $t('logs.zones') }}</h3>
                <div class="tinymce" v-html="log.zones"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="!initialParamsEmpty">
                <ul class="list-group list-group-flush list my--3">

                    <li class="list-group-item px-0" v-if="log.runways">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.runways') }}</div>
                            <div class="col-md-8">{{ log.runways }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.qnh">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.qnh') }}</div>
                            <div class="col-md-8">{{ log.qnh }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.atis">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.atis') }}</div>
                            <div class="col-md-8">{{ log.atis }}</div>
                        </div>
                    </li>

                    <li class="list-group-item px-0" v-if="log.pilots_number">
                        <div class="row align-items-center">
                            <div class="col-md-4 text-uppercase font-weight-bold">{{ $t('logs.pilots-number') }}</div>
                            <div class="col-md-8">{{ log.pilots_number }}</div>
                        </div>
                    </li>

                </ul>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.other">
                <div class="tinymce" v-html="log.other"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.flights">
                <h3 slot="header" class="mb-0">{{ $t('logs.flights') }}</h3>
                <div class="tinymce" v-html="log.flights"></div>
            </card>

            <card class="mb-4" header-classes="border-0 pb-0" v-if="log.current_situation">
                <h3 slot="header" class="mb-0">{{ $t('logs.current-situation') }}</h3>
                <div class="tinymce" v-html="log.current_situation"></div>
            </card>
        </div>

        <div v-else>
            <card type="frame">

                <h3 class="text-uppercase mb-3">{{ $t('logs.flights') }}</h3>
                <div class="pb-4">
                    <editor v-model="value.flights" :height="200"></editor>
                </div>

                <h3 class="text-uppercase mb-3">{{ $t('logs.technical-means') }}</h3>
                <div class="pb-4">
                    <editor v-model="value.technical_means" :height="200"></editor>
                </div>

                <h3 class="text-uppercase mb-3">{{ $t('logs.current-situation') }}</h3>
                <div class="pb-4">
                    <editor v-model="value.current_situation" :height="200"></editor>
                </div>

                <h3 class="text-uppercase mb-3">{{ $t('logs.zones') }}</h3>
                <div class="pb-4">
                    <editor v-model="value.zones" :height="200"></editor>
                </div>

                <div class="row">
                    <div class="col-sm-6">

                        <h3 class="text-uppercase mb-2">{{ $t('logs.runways') }}</h3>

                        <base-input class="mb-3"
                            :placeholder="$t('logs.runways')"
                            v-model="value.runways"
                            name="runways"
                            :error="errors.get('runways')">
                        </base-input>

                        <h3 class="text-uppercase mb-2">{{ $t('logs.qnh') }}</h3>

                        <base-input class="mb-3"
                            :placeholder="$t('logs.qnh')"
                            v-model="value.qnh"
                            name="qnh"
                            :error="errors.get('qnh')">
                        </base-input>

                    </div>
                    <div class="col-sm-6">
                        
                        <h3 class="text-uppercase mb-2">{{ $t('logs.atis') }}</h3>

                        <base-input class="mb-3"
                            :placeholder="$t('logs.atis')"
                            v-model="value.atis"
                            name="atis"
                            :error="errors.get('atis')">
                        </base-input>

                        <h3 class="text-uppercase mb-2">{{ $t('logs.pilots-number') }}</h3>

                        <base-input class="mb-3"
                            :placeholder="$t('logs.pilots-number')"
                            v-model="value.pilots_number"
                            name="pilots_number"
                            :error="errors.get('pilots_number')">
                        </base-input>

                    </div>
                </div>

                <h3 class="text-uppercase mb-3">{{ $t('logs.other') }}</h3>
                <div class="pb-4">
                    <editor v-model="value.other" :height="200"></editor>
                </div>

                <div class="text-center">
                    <base-button native-type="submit" type="primary" :loading="recording" @click="submit">
                        {{ $t('common.save') }}
                    </base-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
    export default {

        props: {

            value: {
                type: Object,
                required: true
            },

            errors: {
                type: Object,
                required: true
            },

            modal: {
                type: Object,
                default: null
            },

            loading: {
                type: Boolean,
                default: false
            },

            recording: {
                type: Boolean,
                default: false
            },

            simulation: {
                type: Object,
                required: true
            },

            log: {
                type: Object,
                required: true
            },

            degree: {
                type: Object,
                required: true
            },
        },

        computed: {

            shared() {
                return this.degree.shared && this.$auth.user.owner_id && this.$auth.user.owner_id != this.degree.owner_id
            },

            canEdit() {
                return !this.shared && this.degree.status != 'archived'
            },

            initialParamsEmpty() {
                return (this.log.runways || this.log.qnh || this.log.atis || this.log.pilots_number) === null
            }
        },

        methods: {
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
